import React, { useEffect, useState } from "react";
import DashboardSidebar from "../../components/DashboardSidebar";
import Nav from "../../components/Nav";
import Select from "react-select";
import { useParams, useNavigate, Link } from "react-router-dom";
import ApiService from "../../services/ApiService";
import ConfirmButton from "../../components/ConfirmButton";

const EditUser = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        username: "",
        password: "",
        role: null,
    });

    const [loading, setLoading] = useState(false);

    const fetchUserData = async () => {
        if (id) {
            setLoading(true);
            try {
                const response = await ApiService.get(`/cms/auth/users/${id}`);
                setFormData({
                    username: response?.username || "",
                    email: response?.email || "",
                    password: "",
                    role: { value: response?.role, label: response?.role.charAt(0).toUpperCase() + response?.role.slice(1) },
                });
            } catch (error) {
                console.error("Error fetching user data:", error);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleInputChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    const handleSave = async () => {
        setLoading(true);
        try {
            if (id) {
                await ApiService.put(`/cms/auth/users/${id}`, {
                    username: formData.username,
                    password: formData.password,
                    role: formData.role?.value,
                });
            } else {
                await ApiService.post(`/cms/auth/users`, {
                    username: formData.username,
                    password: formData.password,
                    role: formData.role?.value,
                });
            }
            navigate("/dashboard/user/list");
        } catch (error) {
            console.error("Error saving user data:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        setLoading(true);
        try {
            await ApiService.delete(`/cms/auth/users/${id}`);
            navigate("/dashboard/user/list");
        } catch (error) {
            console.error("Error deleting user:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUserData();
    }, [id]);

    return (
        <div className="tyn-root dashboard">
            <Nav />
            <div className="tyn-content tyn-content-full-height tyn-chatbot tyn-chatbot-page">
                <div className="tyn-main tyn-content-inner" id="tynMain">
                    <div className="container">
                        <div className={`${id ? "edit-dashboard-nav" : "tyn-profile"} d-flex align-items-center justify-content-between px-5 py-4`} style={{ background: "white", borderRadius: "1rem" }}>
                            <div>
                                <h3 className="text-capitalize center">{id ? "Edit User" : "Add New User"}</h3>
                            </div>
                            <div className="buttons d-flex">
                                <button className="btn btn-primary me-2" onClick={handleSave} disabled={loading}>
                                    {id ? "Save Changes" : "Add User"}
                                </button>

                                <Link className="btn btn-light" to="/dashboard/user/list" aria-label="Cancel and back">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" stroke="currentColor" strokeWidth="0.3" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                                    </svg>
                                    Back to list
                                </Link>
                            </div>
                            <div className="back-btn-mobile" style={{ display: 'none' }}>
                                <Link className="btn btn-light" to="/dashboard/user/list" aria-label="Back to list">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" stroke="currentColor" strokeWidth="0.3" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                                    </svg>
                                </Link>
                            </div>
                        </div>
                        <div className="tyn-profile">
                            <div className="tyn-profile-details mt-4">
                                <div className="tab-content">
                                    <div className="tab-pane show active" id="profile-edit" tabIndex="0">
                                        <div className="row gy-5">
                                            <div className="col-12">
                                                <div className="row gy-4">
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label" htmlFor="username">
                                                                Username *
                                                            </label>
                                                            <div className="form-control-wrap">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="username"
                                                                    placeholder="Username"
                                                                    value={formData.username}
                                                                    onChange={(e) => handleInputChange("username", e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label" htmlFor="password">
                                                                Password {id ? "" : "*"}
                                                            </label>
                                                            <div className="form-control-wrap">
                                                                <input
                                                                    type="password"
                                                                    className="form-control"
                                                                    id="password"
                                                                    placeholder="Password"
                                                                    value={formData.password}
                                                                    onChange={(e) => handleInputChange("password", e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label" htmlFor="role">
                                                                Role *
                                                            </label>
                                                            <div className="form-control-wrap">
                                                                <Select
                                                                    id="role"
                                                                    options={[
                                                                        { value: "user", label: "User" },
                                                                        { value: "admin", label: "Admin" },
                                                                    ]}
                                                                    placeholder="Select Role"
                                                                    value={formData.role}
                                                                    onChange={(selectedOption) =>
                                                                        handleInputChange("role", selectedOption)
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="d-flex justify-content-end buttons mt-5">
                                                            {id && (
                                                                <ConfirmButton className="btn btn-danger me-2" label="Delete" danger={true} action={() => handleDelete()} />
                                                            )}
                                                            <button className="btn btn-primary" onClick={handleSave} disabled={loading}>
                                                                {id ? "Save Changes" : "Add User"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditUser;
